import React from "react";
import { useTranslation } from 'react-i18next'
import {Button, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useSelector} from "react-redux";
import {RootState} from "../../Redux";
import CustomerTokenButton from './Common/CustomerTokenButton'

const ActionSelector = ({ onSelect, footer }) => {
    const { t } = useTranslation()

    const bookingAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.bookingAvailable) || false;
    const driveInAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.driveInAvailable) || false;
    const inspectionReminderAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.inspectionReminderAvailable) || false;
    const registrationServiceAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.registrationServiceAvailable) || false;
    const changeInspectionAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.changeInspectionAvailable) || false;
    const registrationInspectionAvailable = useSelector(
        (state: RootState) => state.ui.settings?.selfService?.registrationInspectionAvailable) || false;
    const showOtherServices = registrationServiceAvailable || changeInspectionAvailable || registrationInspectionAvailable

    const getWith = () => {
        return showOtherServices ? '90%' : '60%'
    }

    const getReminderWith = () => {
        return showOtherServices ? '45%' : '60%'
    }

    const handleSelect = (action: string) => {
        if (onSelect) {
            onSelect(action);
        }
    };

    return (<Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
        <Grid size="grow">
        </Grid>
        <Grid size="grow">
            <Typography variant="h1" gutterBottom style={{textTransform: 'uppercase'}}>
                {t('selfService.title')}
            </Typography>
        </Grid>
        <Grid size="grow" style={{width: getWith()}}>
            {showOtherServices ?
                <Stack direction="row" spacing={4} style={{width: '100%'}}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleSelect("Action 1")}
                    >
                        {bookingAvailable ?
                            <>
                                {t('selfService.selectInspection')}
                                <br/>
                                {t('selfService.selectInspection2')}
                            </>
                            :
                            <>
                                {t('selfService.selectDriveIn')}
                            </>
                        }
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleSelect("Action 2")}
                    >
                        {t('selfService.selectOtherServices')}
                    </Button>
                </Stack>
                :
                <Stack spacing={1} alignItems="center">
                    {bookingAvailable ? null :
                        <Typography variant="subtitle1">
                            {driveInAvailable ? t('selfService.selectDriveInHelpText') : t('selfService.selectCheckInHelpText')}
                        </Typography>
                    }
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleSelect("Action 1")}
                    >
                        {bookingAvailable ?
                            <>
                                {t('selfService.selectInspection')}
                                <br/>
                                {t('selfService.selectInspection2')}
                            </>
                            :
                            <>
                                {t('selfService.selectDriveIn')}
                            </>
                        }
                    </Button>
                </Stack>
            }
        </Grid>
        <Grid>
        </Grid>
        {inspectionReminderAvailable ? <Grid style={{width: getReminderWith()}}>
            <Stack direction="row" spacing={4}>
                <Button
                    fullWidth
                    size={'small'}
                    variant="contained"
                    onClick={() => handleSelect("Action 3")}
                >
                    {t('selfService.selectOrderReminder')}
                </Button>
            </Stack>
        </Grid> : null}
        <Grid size="grow">
        </Grid>
        <Grid size="grow">
            {footer}
        </Grid>
    </Grid>);
};

export default ActionSelector;
